<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
  props: {
    legend: {
      type: Boolean,
      default: true
    }
  },
  extends: Doughnut,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        /*scales: {
          yAxes: [{
            //ticks: {
            //  beginAtZero: true,
            //},
            //gridLines: {
            //  display: true
            //},
            //stacked: true
          }],
          xAxes: [{
            //gridLines: {
            //  display: false
            //},
            //stacked: true
          }]
        },*/
        legend: {
          display: this.legend
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          //mode: 'point'
        }
       }
    }
  },
  methods: {
    handleChartClick(event, elements) {
      console.log('PieChart handleChartClick called with:', event, elements);
      this.$emit('chart-click', event, elements);
    }
  },
  mounted () {
    // Add click handler to options
    this.options.onClick = this.handleChartClick;
    
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
};
</script>
